/* eslint-disable no-case-declarations */
/* eslint-disable semi */
import { LIST, LOADING, RESULT, LINK_MERCHANT_ID, UNBIND_MERCHANT_ID } from './actionTypes';

const INIT_STATE = {
  loading: true,
};

const Linking = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESULT:
      const newState = {
        ...state,
        loading: false,
      };
      switch (action.payload.actionType) {
        case LIST:
          newState['list'] = action.payload.result;
          break;
        case LINK_MERCHANT_ID:
          newState['link_merchant_id'] = action.payload.result;
          break;
        case UNBIND_MERCHANT_ID:
          newState['unbind_merchant_id'] = action.payload.result;
          break;
      }
      return newState;

    default:
      return state;
  }
};

export default Linking;
